import React from 'react';
import DOMPurify from 'dompurify';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';
import COLORS from '@mlb/react-patterns/style/universal.color.ts';
import FONTS from '@mlb/react-patterns/style/fonts.ts';

const Container = styled.div`
    color: ${COLORS.mlbWhite};
    font-family: ${FONTS.primaryFont};
    font-size: 16px;
    max-width: 600px;

    a {
        color: ${COLORS.linkBlueOnDark};
    }

    a:hover {
        color: ${COLORS.linkBlueOnDarkHover};
    }

    p {
        margin-bottom: 1rem;
    }

    ul {
        list-style: disc;
        padding: 0 0 0 18px;
        margin-bottom: 1rem;
    }

    .showOnLarge {
        display: none;
        ${media.lgmin`
            display: block;
        `}
    }
`;

const MessageBody = ({
    content = '',
}) => {

    const cleanContent = DOMPurify.sanitize(content, { ADD_ATTR: ['target'] });

    return (
        <Container
            dangerouslySetInnerHTML={{ __html: cleanContent }}
        >
        </Container>
    );

};

export default MessageBody;
